import {IconButton, InputAdornment, TextField} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import React, {useState} from "react";

const PasswordField = ({name, label, value, onChange}) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const handleClickShowPassword = () => {
        setShowPassword((show) => !show);
        }
        
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
        }
        
    return <TextField
                required
                fullWidth
                name={name}
                onChange={onChange}
                label={label}
                value={value}
                type={showPassword ? 'text' : 'password'}
                minLen={8}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                     ),
                    }}
                />;
    }
    
export default PasswordField;